<template>
    <div class="discount">
        <div class="text">{{discount.desc}}</div>
        <DiscountVip/>
        <div class="title">会员权益</div>
        <div class="benefits">
            <div class="item" v-for="(item, index) in benefits" :key="index">
                <img :src="item.image" alt="" class="icon">
                <p>{{item.text}}</p>
            </div>
        </div>
        <div class="title">入驻企业专享福利</div>
        <div class="welfare">
            <div class="item" v-for="(item, index) in welfare" :key="index">
                <img :src="item.image" alt="" class="icon">
                <p>{{item.text}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DiscountVip from '../../components/discountVip.vue';
export default {
    name: "discount",
    data() {
        return {
            benefits: [
                { text: '消费奖励积分', image: require('@/assets/images/icon_benefits_01.jpg') },
                { text: '特色优享活动', image: require('@/assets/images/icon_benefits_02.jpg') },
                { text: '免费停车礼遇', image: require('@/assets/images/icon_benefits_03.jpg') },
                { text: '严选礼品专区', image: require('@/assets/images/icon_benefits_04.jpg') },
                { text: '定制贴心服务', image: require('@/assets/images/icon_benefits_05.jpg') },
            ],
            welfare: [
                { text: 'i天地会员权益', image: require('@/assets/images/icon_welfare_01.png') },
                { text: '活动场地租用', image: require('@/assets/images/icon_welfare_02.png') },
                { text: '公司实地注册', image: require('@/assets/images/icon_welfare_03.png') },
                { text: '免费WIFI', image: require('@/assets/images/icon_welfare_04.png') },
                { text: '商业需求对接和解决', image: require('@/assets/images/icon_welfare_05.png') },
                { text: '保安保洁服务', image: require('@/assets/images/icon_welfare_06.png') },
                { text: '定期社区活动', image: require('@/assets/images/icon_welfare_07.png') },
                { text: '访客接待服务', image: require('@/assets/images/icon_welfare_08.png') },
            ]
        };
    },
    computed: {
        ...mapState(['discount'])
    },
    components: {
        DiscountVip
        
    },
    mounted() {
        this.$store.dispatch('getDiscount');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.discount{
    .text{
        margin-bottom: .5rem;
    }
    .title{
        font-size: .26rem;
        text-align: center;
        margin: .6rem 0;
    }
    .benefits{
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
        .item{
            text-align: center;
            .icon{
                // width: .96rem;
                width: .72rem;
                margin: 0 auto .3rem;
            }
        }
    }
    .welfare{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
            width: 20.1%;
            text-align: center;
            &:nth-of-type(1),
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(4){
                margin-bottom: .6rem;
            }
            .icon{
                width: .64rem;
                margin: 0 auto .15rem;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .text{
            padding: 0 1rem;
            margin-bottom: 1rem;
        }
        .title{
            font-size: .72rem;
            line-height: 1;
            padding: 1.2rem 1rem;
            margin: 0;
        }
        .benefits{
            flex-wrap: wrap;
            margin-bottom: 0;
            .item{
                width: 50%;
                margin: 0;
                margin-top: 1.5rem;
                &:nth-of-type(1),
                &:nth-of-type(2){
                    margin-top: 0;
                }
                .icon{
                    width: 1.3rem;
                    margin-bottom: .7rem;
                }
            }
        }
        .welfare{
            .item{
                width: 50%;
                margin: 0 !important;
                margin-top: 1.6rem !important;
                &:nth-of-type(1),
                &:nth-of-type(2){
                    margin-top: 0 !important;
                }
                .icon{
                    width: 1.3rem;
                    margin-bottom: .4rem;
                }
            }
        }
    }
}
</style>